export enum SearchDateAdultsModeEnum {
  DEFAULT = 'DEFAULT',
  ALTERNATIVE = 'ALTERNATIVE',
  IN_HOUSE_CARD = 'IN_HOUSE_CARD',
  IN_HOUSE_CARD_AUTONOMOUS_BOOKING = 'IN_HOUSE_CARD_AUTONOMOUS_BOOKING',
  SEARCH = 'SEARCH',
  ACTIVE_SEARCH = 'ACTIVE_SEARCH',
}
